import { matchPath } from 'react-router-dom'

import {
  PASSPORT_PATHS,
  PUBLIC_BRAND_PROFILE,
  PUBLIC_INSTAGRAM_LANDING,
  PUBLIC_NOT_FOUND,
  PUBLIC_RETAILER_PROFILE,
  PUBLIC_STOREFRONT,
} from 'routes/paths'

export function isAnonymousRoute() {
  const paths = [
    ...PASSPORT_PATHS,
    PUBLIC_BRAND_PROFILE,
    PUBLIC_STOREFRONT,
    PUBLIC_INSTAGRAM_LANDING,
    PUBLIC_NOT_FOUND,
    PUBLIC_RETAILER_PROFILE,
  ]

  const match = paths.some((path) =>
    matchPath({ path, end: true }, window.location.pathname),
  )

  return match
}
